import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createEpicMiddleware } from 'redux-observable';

import './index.scss';
import { init as initStore } from './redux/store';
import epics from './redux/epics/epics';
import App from './App';
import reportWebVitals from './reportWebVitals';

const epicMiddleware = createEpicMiddleware();
const store = initStore({epicMiddleware});
epicMiddleware.run(epics); // apply the redux-observable middleware
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
